import { writable } from "svelte/store";
import type { CartType } from "@shared/types/Cart";
import { loadCart } from "@retailer/svelte/CartWidget/v2/Services/CartRequestService";

const _store = writable<CartType>();
const { subscribe, set, update } = _store;

const store = {
  subscribe,
  set,
  update,

  load: async () => {
    let cart = await loadCart();
    set(cart);
  },
};

export default store;
